import styles from './ErrorMessage.module.scss'

interface ErrorMessageProps {
  message?: string
}

const ErrorMessage = ({ message = '' }: ErrorMessageProps) => {
  return <span className={styles.requiredMessage}>{message}</span>
}

export default ErrorMessage
